import {Component, OnInit} from '@angular/core';
import {ErrorService} from "src/app/modules/error/error.service";

@Component({
    selector: 'app-timeout',
    templateUrl: './timeout.component.html',
    styleUrls: ['./timeout.component.scss']
})
export class TimeoutComponent implements OnInit {

    errorMessage: string = null;

    constructor(private errorService: ErrorService) {
    }

    ngOnInit(): void {
        this.errorMessage = this.errorService.getErrorMessage();
        this.errorService.setErrorMessage(null);
    }

}
